import React from 'react';

import {
  Button,
  ButtonGroup,
  Hoverable,
  Popover,
} from '@zapier/common-components';

type ChangePlanButtonsProps = {
  isDisabled: boolean;
  onCancelChangePlan: () => void;
  onChangePlan: () => void;
  popoverText: string | null | undefined;
  submitText: string;
};

export const ChangePlanButtons = ({
  isDisabled,
  onCancelChangePlan,
  onChangePlan,
  popoverText,
  submitText,
}: ChangePlanButtonsProps) => {
  return (
    <ButtonGroup
      propsQueries={{
        tabletPortraitPlus: {
          direction: 'row',
          isReversed: true,
          justify: 'flex-start',
        },
      }}
    >
      <Hoverable>
        {({ isHovered }: { isHovered: boolean }) => (
          <Popover
            content={popoverText}
            isCompact={true}
            noWrap={true}
            role="tooltip"
            show={isDisabled && isHovered}
            theme="dark"
          >
            <Button
              color="primary"
              isDisabled={isDisabled}
              isFullWidth={true}
              label="change plan"
              onClick={onChangePlan}
            >
              {submitText}
            </Button>
          </Popover>
        )}
      </Hoverable>
      <Button
        backgroundType="clear"
        color="secondary"
        label="cancel change plan"
        onClick={onCancelChangePlan}
        type="button"
      >
        Cancel
      </Button>
    </ButtonGroup>
  );
};
